import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ListResponse } from '@daikin-tic/dxone-com-lib';

import { DeviceSet, DeviceSetCreateParams, DeviceSetQueryParams } from '../models/device-set.model';
import { DeviceSetGateway } from '../usecases/device-set.gateway';

@Injectable()
export class DeviceSetService extends DeviceSetGateway {
  constructor(private _http: HttpClient) {
    super();
  }

  override listDeviceSets(params: DeviceSetQueryParams): Observable<ListResponse<DeviceSet>> {
    return this._http.get<ListResponse<DeviceSet>>('api/rss/device-sets', { params });
  }

  override createDeviceSet(params: DeviceSetCreateParams): Observable<DeviceSet> {
    return this._http.post<DeviceSet>('api/rss/device-sets', params);
  }

  override deleteDeviceSet(deviceSetId: string): Observable<void> {
    return this._http.delete<void>(`api/rss/device-sets/${deviceSetId}`);
  }
}
